'use client';

import styles from '../../page.module.scss';
import underline1 from '../../assets/decos/Underline_03.svg';
import BookCard from './cards/BookCard';
import Link from 'next/link';

interface Book {
  mainTitle: string;
  authors: any;
  cardImage: string;
  published?: boolean;
  id?: string;
  slug?: string;
}

interface BookCoversProps {
  books: Book[];
  loading: boolean;
}

const BookCovers: React.FC<BookCoversProps> = ({ books, loading }) => {
  return (
    <section id="catalogo" className={styles.booksSection}>
      <h2 className={styles.title}>Catálogo</h2>
      <img src={underline1.src} alt="línea de decoración" />

      <div className={styles.flyerContainer}>
        {!loading
          ? [...books].reverse().map(
              (book: Book, index: number) =>
                book.published && (
                  <div className={styles.mapItemContainer} key={index}>
                    <Link href={`/libros/${book.slug}`}>
                      <BookCard
                        id={book.id}
                        title={book.mainTitle}
                        authors={book.authors.join(' - ')}
                        image={book.cardImage}
                      />
                    </Link>
                  </div>
                )
            )
          : [1, 2, 3, 4, 5, 6].map((art: any, index: number) => (
              <div key={index} className={`${styles.bookCard} ${styles.cardLoader} `}></div>
            ))}
      </div>
    </section>
  );
};

export default BookCovers;
